module.exports = {"361102001":"水南街道","361102002":"东市街道","361102003":"西市街道","361102004":"北门街道","361102005":"茅家岭街道","361102006":"灵溪街道","361102100":"沙溪镇","361102102":"朝阳镇","361102103":"秦峰镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361102.json
// module id = 1238
// module chunks = 0